var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "floating-dock-toggle",
      class: { "floating-dock-toggle--collapsed": _vm.collapsed },
      attrs: {
        type: "button",
        "aria-pressed": _vm.collapsed ? "true" : "false",
        "aria-label": _vm.collapsed
          ? "Expandir atalhos flutuantes"
          : "Recolher atalhos flutuantes",
        title: _vm.collapsed ? "Expandir atalhos" : "Recolher atalhos"
      },
      on: { click: _vm.onToggle }
    },
    [
      _c(
        "v-fab-transition",
        { attrs: { mode: "out-in" } },
        [
          _c("icon-svg", {
            key: _vm.collapsed ? "expand" : "collapse",
            attrs: {
              name: _vm.collapsed ? "mdi-chevron-left" : "mdi-chevron-right",
              size: 22,
              color: "#FFFFFF"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }